import React from 'react';

import styled from 'styled-components';
import { UserContext } from '../UserProvider';
import { DataContext } from '../DataProvider';

import AuthDialog from '../AuthDialog';

// import ProjectDialog from '../ProjectDialog';
// import ProjectDropdown from '../ProjectDropdown';

function NavBar() {
  const { isAuthenticated, handleLogout } = React.useContext(UserContext);
  const { fakevalue } = React.useContext(DataContext);

  const LoginLogout = isAuthenticated ? (
    <button class='btn-login' onClick={handleLogout}>
      Logout
    </button>
  ) : (
    <button class='btn-login'>
      <AuthDialog />
    </button>
  );

  return <>{LoginLogout}</>;
}

export default NavBar;

const NavItem = styled.button`
  background-color: var(--number-box-background-color);
  color: white !important;
  margin-top: 10px;
  margin-right: 10px;
  border: 1px solid rgba(68, 71, 156, 0.718);
  padding: 10px 20px;
  border-radius: 10px;
  background-color: #1a2246;
  &:hover {
    background-color: #5061ff;
    color: white;
  }
  /* width: 100px; */
  display: flex;
  /* height: 50px; */
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;

  a {
    text-decoration: none;
    color: inherit;
  }
`;
